module.exports = __webpack_public_path__ + "img/kuo32.02bb1069.png";